import * as tslib_1 from "tslib";
import { Store, select } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContainerBase } from '../../../core/base/container-base';
import { DetailsContainer } from '../../../catalog/containers/details-container/details-container';
import * as fromOrderHistory from '../../reducers';
import * as fromAuth from '../../../auth/reducers';
import * as orderhistory from '../../actions/order-history.actions';
import * as product from '../../../catalog/actions/product';
import * as catalog from '../../../catalog/actions/catalog';
import * as fromCart from '../../../cart/reducers';
var OrderhistorylinesPageContainerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(OrderhistorylinesPageContainerComponent, _super);
    function OrderhistorylinesPageContainerComponent(store, modalSvc) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.modalSvc = modalSvc;
        _this.orderHistoryItem$ = store.pipe(select(fromOrderHistory.getOrderHistoryItem), takeUntil(_this.destroyed$));
        _this.orderHistoryLines$ = store.pipe(select(fromOrderHistory.getOrderHistoryLines), takeUntil(_this.destroyed$));
        _this.loading$ = store.pipe(select(fromOrderHistory.getOrderHistoryLinesLoading), takeUntil(_this.destroyed$));
        _this.expanding$ = store.pipe(select(fromOrderHistory.getOrderHistoryLinesExpanding), takeUntil(_this.destroyed$));
        _this.cartProducts$ = store
            .pipe(select(fromCart.getCartProducts), takeUntil(_this.destroyed$));
        _this.reOrderableProductCodes$ = store.pipe(select(fromOrderHistory.getReOrderableItemCodes), takeUntil(_this.destroyed$));
        _this.currency$ = store.pipe(select(fromAuth.getCurrency), takeUntil(_this.destroyed$));
        _this.store.dispatch(new orderhistory.LoadOrderHistoryItem());
        _this.store.dispatch(new orderhistory.LoadOrderHistoryLines());
        _this.store.dispatch(new orderhistory.LoadReOrderableItems());
        return _this;
    }
    OrderhistorylinesPageContainerComponent.prototype.expand = function () {
        this.store.dispatch(new orderhistory.LoadOrderHistoryLinesExpand());
    };
    OrderhistorylinesPageContainerComponent.prototype.reOrder = function (productId) {
        this.store.dispatch(new catalog.Init());
        this.store.dispatch(new product.Select(productId));
        this.modalSvc.open(DetailsContainer, { centered: true, size: 'lg' });
    };
    return OrderhistorylinesPageContainerComponent;
}(ContainerBase));
export { OrderhistorylinesPageContainerComponent };
